import React from "react";
import Slider from "react-slick";


function ServiceDetail() {
    // Slider settings
    const settings = {
        dots: true,
        infinite: true,
        speed: 600,
        slidesToShow: 2,
        slidesToScroll: 1,
        centerMode: false,
        arrows: true,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                },
            },
        ],
    };

    return (
        <>
            {/* Banner */}
            <section className="inner-banner-wrap">
                <div
                    className="inner-baner-container"
                    style={{ backgroundImage: "url(assets/images/banner-pattern1.png)" }}
                >
                    <div className="container">
                        <div className="inner-banner-content">
                            <h1 className="inner-title">Best Market Planning</h1>
                        </div>
                    </div>
                </div>
            </section>

            {/* Service Section */}
            <div className="service-detail-section">
                <div className="container">
                    <div className="service-inner-detail">
                        <div className="row">
                            {/* Left Content */}
                            <div className="col-lg-8 right-sidebar">
                                <figure className="service-img">
                                    <img src="assets/images/img8.jpg" alt="Market Planning" />
                                </figure>

                                <h3>Smart Market Strategies</h3>
                                <p>
                                    We help businesses grow with data-driven strategies, customer
                                    insights, and innovative campaigns. Our team ensures your
                                    brand connects with the right audience at the right time.
                                </p>

                                <article className="service-detail-list">
                                    <ul>
                                        <li>
                                            <i className="fas fa-check-circle" />
                                            Customer-focused planning
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle" />
                                            Competitive market research
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle" />
                                            Campaign design & execution
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle" />
                                            Multi-channel promotion
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle" />
                                            Data analysis & reporting
                                        </li>
                                        <li>
                                            <i className="fas fa-check-circle" />
                                            Ongoing growth support
                                        </li>
                                    </ul>
                                </article>

                                {/* Image Slider with Pagination */}
                                <div className="gallery-slider1 ">
                                    <Slider {...settings}>
                                        <div className="gallery-item px-3">
                                            <img src="assets/images/img5.jpg" alt="Planning Step 1" />
                                        </div>
                                        <div className="gallery-item px-3">
                                            <img src="assets/images/img7.jpg" alt="Planning Step 2" />
                                        </div>
                                        <div className="gallery-item px-3">
                                            <img src="assets/images/img6.jpg" alt="Planning Step 3" />
                                        </div>
                                        <div className="gallery-item px-3">
                                            <img src="assets/images/img2.jpg" alt="Planning Step 4" />
                                        </div>
                                    </Slider>
                                </div>

                            </div>

                            {/* Sidebar */}
                            <div className="col-lg-4">
                                <div className="sidebar">
                                    {/* Form */}
                                    <div className="widget widget-bg widget-form">
                                        <h4 className="bg-title primary-bg">Get in Touch</h4>
                                        <form className="widget-from-inner">
                                            <p>
                                                <input
                                                    type="text"
                                                    name="name"
                                                    placeholder="Enter Name*"
                                                />
                                            </p>
                                            <p>
                                                <input
                                                    type="email"
                                                    name="email"
                                                    placeholder="Enter Email*"
                                                />
                                            </p>
                                            <p>
                                                <input
                                                    type="text"
                                                    name="subject"
                                                    placeholder="Enter Subject*"
                                                />
                                            </p>
                                            <p>
                                                <textarea rows={6} placeholder="Enter Message*" />
                                            </p>
                                            <p>
                                                <input
                                                    type="submit"
                                                    name="submit"
                                                    value="SUBMIT MESSAGE"
                                                />
                                            </p>
                                        </form>
                                    </div>

                                    {/* Other Services */}
                                    <div className="widget widget-bg icon-list-content">
                                        <h4 className="bg-title">Our Other Services</h4>
                                        <ul>
                                            <li>
                                                <a href="#">
                                                    <i className="fas fa-arrow-circle-right" />
                                                    Creation & Branding
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fas fa-arrow-circle-right" />
                                                    Launch Campaigns
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fas fa-arrow-circle-right" />
                                                    Market Planning
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fas fa-arrow-circle-right" />
                                                    Digital Marketing
                                                </a>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <i className="fas fa-arrow-circle-right" />
                                                    Project Management
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            {/* Sidebar End */}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ServiceDetail;